/**
 * @generated SignedSource<<608f99926a1820f51d0d790ce05f685e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppBreadcrumbs_task$data = {
  readonly build: {
    readonly branch: string;
    readonly changeIdInRepo: string;
    readonly id: string;
    readonly repository: {
      readonly id: string;
      readonly name: string;
      readonly owner: string;
      readonly platform: string;
    };
  };
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "AppBreadcrumbs_task";
};
export type AppBreadcrumbs_task$key = {
  readonly " $data"?: AppBreadcrumbs_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppBreadcrumbs_task">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppBreadcrumbs_task",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Build",
      "kind": "LinkedField",
      "name": "build",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "branch",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "changeIdInRepo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "platform",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "owner",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};
})();

(node as any).hash = "673966bb5482e577ca6767c57b066f6c";

export default node;
